import React from 'react'
import Switch from 'react-switch'

const switchOptions = {
    className: 'rtf-toggle-switch',
    offColor: '#fff',
    onColor: '#1C75BC',
    offHandleColor: '#1C75BC',
    onHandleColor: '#fff',
    handleDiameter: 14,
    uncheckedIcon: false,
    checkedIcon: false,
    height: 24,
    width: 40
}

export const AccessRow = ({ avatar, name, detail, pill, extra, checked, reason, locked, onChange }) => (
    <div className="rt-row">
        <span className="rt-avatar" aria-hidden="true">{avatar}</span>
        <div className="rt-row-body">
            <div className="rt-row-title">
                <span className="rt-row-name">{name}</span>
                {pill}
            </div>
            {detail && <div className="rt-row-detail">{detail}</div>}
            {extra && <div className="rt-row-extra">{extra}</div>}
            {reason && <div className="rt-row-reason">{reason}</div>}
        </div>
        <Switch
            aria-label={__('Access for :name', { ':name': name })}
            checked={checked}
            disabled={Boolean(reason) || Boolean(locked)}
            onChange={onChange}
            {...switchOptions}
        />
    </div>
)
